export class DeviceScanResult {
  manufacturerId?: string;
  version?: number;
  dueDate?: string;
  serialNumber?: string;
  unknownProperties?: string;

  addManufacturerId(manufacturerId: string) {
    this.manufacturerId = manufacturerId;
    return this;
  }

  addVersion(version: number) {
    this.version = version;
    return this;
  }

  addDueDate(dueDate: string) {
    this.dueDate = dueDate;
    return this;
  }

  addSerialNumber(serialNumber: string) {
    this.serialNumber = serialNumber;
    return this;
  }

  addUnknownProperties(unknownProperties: string) {
    this.unknownProperties = unknownProperties;
    return this;
  }
}

export class BatteryPackScanResult {
  serialNumberBatteryPack?: string;
  customizedNumberBatteryPack?: string;
  productKey?: string;
  unknownProperties: string;

  constructor(
    serialNumberBatteryPack?: string,
    customizedNumberBatteryPack?: string,
    unknownProperties = '',
    productKey?: string
  ) {
    this.serialNumberBatteryPack = serialNumberBatteryPack;
    this.customizedNumberBatteryPack = customizedNumberBatteryPack;
    this.unknownProperties = unknownProperties;
    this.productKey = productKey;
  }
}

export class LoRaWanMatrixScanResult {
  serialNumber?: string;
  eui?: string;
  customizedNumber?: string;
  unknownProperties?: string;

  addSerialNumber(serialNumber: string) {
    this.serialNumber = serialNumber;
    return this;
  }

  addEUI(eui: string) {
    this.eui = eui;
    return this;
  }

  addCustomizedNumber(customizedNumber: string) {
    this.customizedNumber = customizedNumber;
    return this;
  }
  addUnknownProperties(unknownProperties: string) {
    this.unknownProperties = unknownProperties;
    return this;
  }
}

export class SRTAdapterScanResult {
  customizedNumber: string;
  productKey: string;
  unknownProperties: string;

  constructor() {
    this.customizedNumber = '';
    this.productKey = '';
    this.unknownProperties = '';
  }

  addCustomizedNumber(customizedNumber: string) {
    this.customizedNumber = customizedNumber;
    return this;
  }

  addProductKey(productKey: string) {
    this.productKey = productKey;
    return this;
  }

  addUnknownProperties(unknownProperties: string) {
    this.unknownProperties = unknownProperties;
    return this;
  }
}
